import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

/**
 * Historique des modifications d'adresse de livraison d'une commande
 * (stocké dans le BO), par ordre chronologique
 */
function useGetShippingAddressHistory(orderId) {
  const { data, error, isLoading, mutate } = useSWR(
    orderId ? `/orders/${orderId}/shippingAddress/history` : null,
    (url) => fetcher(url),
    { revalidateOnFocus: true }
  );

  return {
    history: data?.data || [],
    isLoading,
    error,
    mutate,
  };
}

export default useGetShippingAddressHistory;
